module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "container",
    style: (("transform: translate(" + x + "px, " + y + "px) scale(" + scale + ");"))
  }, [_h('div', {
    staticClass: "animal",
    domProps: {
      "innerHTML": _s(image.animal[playing ? (animal + "Sound") : animal])
    }
  }), " ", (hat) ? _h('div', {
    staticClass: "hat",
    style: (("left: " + (hatPosition.x * 100) + "%; top: " + (hatPosition.y * 100) + "%; width: " + (hat.width * 100) + "%;")),
    domProps: {
      "innerHTML": _s(image.hat[hat.key])
    }
  }) : _e()])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-00dbfba7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Animal.vue
 ** module id = 161
 ** module chunks = 2
 **/